module.exports = __webpack_public_path__ + "static/media/KinoLogoWhiteBG.e56343fb.svg";